module.exports = __webpack_public_path__ + "img/img_123.c22d1508.jpg";